/**
 * Semáforo mínimo para limitar concurrencia de subidas (4 a la vez).
 * Devuelve un wrapper: `limit(() => promesa)` encola si no hay hueco.
 */
export function createSemaphore(max: number) {
  let active = 0;
  const queue: Array<() => void> = [];

  const next = () => {
    active--;
    const run = queue.shift();
    if (run) run();
  };

  return async function limit<T>(fn: () => Promise<T>): Promise<T> {
    if (active >= max) {
      await new Promise<void>((resolve) => queue.push(resolve));
    }
    active++;
    try {
      return await fn();
    } finally {
      next();
    }
  };
}
